export const MENU_LIST = {
    ANALAYSIS_LIST: {
        path: '/analysis/list',
        displayName: 'menu.clientManagement'
    },
    ANALAYSIS_UPLOAD: {
        path: '/analysis/upload',
        displayName: 'menu.clientManagement'
    }
}

export const LANG_EN = 'en'
export const LANG_JP = 'jp'

export const LANG_LIST = [
    { content: '日本語', value: LANG_JP },
    { content: 'ENGLISH', value: LANG_EN }
]
